// extracted by mini-css-extract-plugin
export default {"NavbarContainer":"Navbar_NavbarContainer__dUBvX","image":"Navbar_image__kRUN7","linkVVL":"Navbar_linkVVL__N1LCe"};